import helperSource from '../../../docs/spec/viz/viz-helper.swift?raw';
import { attachVizHelper } from './attach';

/** viz 補助の正本（docs/spec/viz/viz-helper.swift）。ビルド時に取り込む。 */
export const VIZ_HELPER: string = helperSource;

/** 正本の補助で {@link attachVizHelper} を呼ぶ。 */
export function withVizHelper(userCode: string): ReturnType<typeof attachVizHelper> {
  return attachVizHelper(userCode, VIZ_HELPER);
}
